import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, MaskText } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { CONTACT, waLink } from "@/lib/contact";
import { Instagram, MessageCircle, Mail, Facebook, MapPin } from "lucide-react";

export default function Contacto() {
  const { t, tr } = useLang();

  const CHANNELS = [
    { icon: <MessageCircle className="h-6 w-6" />, label: "WhatsApp", value: tr("Escríbenos", "Message us"), href: waLink(tr("Hola VORNA, quisiera más información.", "Hi VORNA, I'd like more info.")), test: "contact-whatsapp" },
    { icon: <Instagram className="h-6 w-6" />, label: "Instagram", value: "@vorna.fightwear", href: CONTACT.instagram, test: "contact-instagram" },
    { icon: <Facebook className="h-6 w-6" />, label: "Facebook", value: "VORNA", href: CONTACT.facebook, test: "contact-facebook" },
    { icon: <Mail className="h-6 w-6" />, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, test: "contact-email" },
  ];

  return (
    <div data-testid="contact-page" className="pt-16 lg:pt-20">
      <Seo
        title={tr("Contacto | VORNA", "Contact | VORNA")}
        description={tr("Escríbenos por WhatsApp o síguenos en Instagram. VORNA — fightwear ecuatoriano, Quito, Ecuador.", "Message us on WhatsApp or follow us on Instagram. VORNA — Ecuadorian fightwear, Quito, Ecuador.")}
        path="/contacto"
      />
      <div className="border-b border-white/10 bg-vorna-surface">
        <div className="mx-auto max-w-[1600px] px-5 lg:px-10 py-16 lg:py-24">
          <p className="text-xs tracking-[0.35em] text-vorna-accent uppercase mb-4">{tr("Hablemos", "Get in touch")}</p>
          <h1 className="font-display uppercase tracking-tighter text-6xl lg:text-8xl leading-[0.8]"><MaskText lines={tr(["Contacta", "a VORNA"], ["Contact", "VORNA"])} /></h1>
        </div>
      </div>

      <section className="mx-auto max-w-[1600px] px-5 lg:px-10 py-16 lg:py-24">
        <Reveal>
          <p className="max-w-2xl text-lg text-white/60 leading-relaxed mb-12">
            {tr("¿Quieres saber si un producto está disponible, qué tallas y colores hay, o el precio? Escríbenos directamente. Estaremos encantados de ayudarte.",
                "Want to know if a product is available, which sizes and colors we have, or the price? Message us directly — we're happy to help.")}
          </p>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {CHANNELS.map((c) => (
            <Reveal key={c.label}>
              <a href={c.href} target="_blank" rel="noreferrer" data-testid={c.test} className="group flex flex-col justify-between h-52 border border-white/10 p-8 hover:border-vorna-accent transition-colors">
                <div className="text-vorna-accent">{c.icon}</div>
                <div>
                  <p className="text-[11px] tracking-widest text-white/40 uppercase">{c.label}</p>
                  <p className="font-display uppercase tracking-tight text-2xl mt-1 group-hover:text-vorna-accent transition-colors">{c.value}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-8 flex items-center gap-4 border border-white/10 p-8">
            <MapPin className="h-6 w-6 text-vorna-accent shrink-0" />
            <div>
              <p className="text-[11px] tracking-widest text-white/40 uppercase">{tr("Sede", "Headquarters")}</p>
              <p className="font-display uppercase tracking-tight text-xl mt-1">{CONTACT.city} 🇪🇨</p>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
